import React, {Component} from 'react';
import {Button, ControlLabel, Form, FormControl, FormGroup, Glyphicon, HelpBlock} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {Auth} from 'aws-amplify/lib/index';
import validator from 'validator';
import ErrorComponent from '../ErrorComponent';

class ResetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirm: '',
      code: '',
      password: '',
      email: '',
      resetting: false,
      error: null,
      errors: {},
      reset: false
    };
  }

  validateForm = () => {
    const requiredFields = ['code', 'password', 'confirm', 'email'];
    let errors = {};

    requiredFields.forEach(f => {
      if (validator.isEmpty(this.state[f])) {
        errors[f] = 'This is a required field.';
      }
    });

    if (!validator.isEmail(this.state.email)) {
      errors.email = 'Invalid email address.';
    }

    if (this.state.password !== this.state.confirm) {
      errors.confirm = 'Must match password.';
    }
    this.setState({ errors });

    return Object.entries(errors).reduce((res, e) => res || !!e, false);
  };

  handleChange = event => {
    this.setState({[event.target.id]: event.target.value});
  };

  handleSubmit = async event => {
    event.preventDefault();

    if (!this.validateForm()) {
      try {
        this.setState({ resetting: true });
        await Auth.forgotPasswordSubmit(this.state.email, this.state.code, this.state.password);

        this.setState({ reset: true, resetting: false });
      } catch (e) {
        let error = [{ code: e.code, msg: 'Failed to reset password. Please try again later.' }];
        switch (e.code) {
          case 'CodeMismatchException':
            error[0].msg = 'Invalid reset code.';
            break;
          default:
            break;
        }
        this.setState({ error, resetting: false });
      }
    }
  };

  render() {
    if (this.state.reset) {
      return (
        <p className='ta-center'>Password successfully reset!</p>
      );
    }

    return (
      <div className={'Reset'}>
        { this.state.error &&
        <ErrorComponent error={this.state.error}/>
        }
        <h2 className='ta-center'>Reset Password</h2>
        <Form onSubmit={this.handleSubmit} className='max-width'>
          <FormGroup validationState={this.state.errors && this.state.errors.email ? 'error' : null } controlId="email">
            <ControlLabel>Email:</ControlLabel>
            <FormControl
              data-cy='reset-email'
              type='text'
              value={this.state.email}
              onChange={this.handleChange}
            />
            <FormControl.Feedback />
            { this.state.errors.email ? <HelpBlock>{this.state.errors.email}</HelpBlock> : '' }
          </FormGroup>
          <FormGroup validationState={this.state.errors && this.state.errors.code ? 'error' : null } controlId="code">
            <ControlLabel>Reset Code:</ControlLabel>
            <FormControl
              data-cy='reset-code'
              type='text'
              value={this.state.code}
              onChange={this.handleChange}
            />
            <FormControl.Feedback />
            { this.state.errors.code ? <HelpBlock>{this.state.errors.code}</HelpBlock> : '' }
          </FormGroup>
          <FormGroup validationState={this.state.errors && this.state.errors.password ? 'error' : null } controlId="password">
            <ControlLabel>Password:</ControlLabel>
            <FormControl
              data-cy="reset-password"
              type="password"
              value={this.state.password}
              onChange={this.handleChange}/>
            <FormControl.Feedback />
            { this.state.errors.password ? <HelpBlock>{this.state.errors.password}</HelpBlock> : '' }
          </FormGroup>
          <FormGroup validationState={this.state.errors && this.state.errors.confirm ? 'error' : null } controlId="confirm">
            <ControlLabel>Confirm Password:</ControlLabel>
            <FormControl
              data-cy="confirm-password"
              type="password"
              value={this.state.confirm}
              onChange={this.handleChange}/>
            <FormControl.Feedback />
            { this.state.errors.confirm ? <HelpBlock>{this.state.errors.confirm}</HelpBlock> : '' }
          </FormGroup>
          <Button data-cy="reset-button"
                  block
                  disabled={this.state.resetting}
                  type="submit">
            { this.state.resetting ? 'Loading...  ' : 'Reset Password' }
            { this.state.resetting && <Glyphicon glyph="refresh" className="spinning" /> }
          </Button>
          <Link to={'/forgot'}><p data-cy='resend-link' style={{ marginTop: '3px' }}>Resend Code</p></Link>
        </Form>
      </div>
    );
  }
}

export default ResetPassword;



// WEBPACK FOOTER //
// ./src/components/user/ResetPassword.js